<template>
  <div class="text-s flex-column width-expand gap-xs">
    <!--<strong>{{translateNumber(item.quantity)}} units</strong>-->
    <span>{{ product.code }}, {{ product.color }}</span>
    <span>{{
        translateUcFirst("ecommerce.cart.fromVendor", {
          vendorName: product.Vendor.name,
        })
      }}</span>
    <strong>{{
        translateUcFirst("justopp.checkout.allExclVat")
      }}</strong>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    quote: {
      type: [Object,Boolean],
      default: false,
    },
  },
  data: function () {
    return {}
  },
  computed: {
    product() {
      console.log(this.item);
      return this.item.cartItem.Product;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
